import React, { h } from "preact";
import {t} from "../../_i18n";
import {Card} from "../../_common/layout";
import {ButtonGhost} from "../../_common/components/buttons/buttons";
import {Section, TextLabel} from "./components";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import Badge from "../../_common/components/Badge";
import {Tooltip} from "../../_common/components/Tooltip/Tooltip";

export default function ProfileData({fullName, address, phone, nickname, linkAddress, linkTelephone, linkNee, linkNickname}) {
    const neeData = useSelector(state => state.neeDocumentStatus?.data)
    const neeStatus = useSelector(state => state.neeDocumentStatus?.status)
    return (
        <div className='p-left-half sm-no-p-left p-right-half sm-no-p-right'>
            <Card className='sm-p-x2-bottom '>
                <div className='font-24 font-medium m-top'>{fullName}</div>
                <Section className='m-x2-top'>
                    <TextLabel label={t('Dirección')} value={address}/>
                    <Link to={linkAddress}>
                        <ButtonGhost
                            className='m-top sm-no-m-top full-width sm-no-full-width'>{t('Cambiar')}</ButtonGhost>
                    </Link>
                </Section>
                <hr className="separator-xxs"/>
                <Section>
                    <TextLabel label={t('Teléfono')} value={phone}/>
                    <Link to={linkTelephone}>
                        <ButtonGhost
                            className='m-top sm-no-m-top full-width sm-no-full-width'>{t('Cambiar')}</ButtonGhost>
                    </Link>
                </Section>
                <hr className="separator-xxs"/>
                <Section>
                    <TextLabel label={t('Necesidades educativas especiales')} value={neeData?.nee_level || t('Ninguna')}/>
                    {neeData?.status_id === 2 && <Badge type='warning' className='m-top-half'>{t('Revisar')}</Badge>}
                    <Tooltip text={!neeStatus?.enabled ? `${t('Los documentos solo se pueden actualizar en el periodo de validación')}.` : null}>
                        <Link to={!neeStatus?.enabled ? '#' : linkNee}>
                            <ButtonGhost
                                className='m-top sm-no-m-top full-width sm-no-full-width'
                                disabled={!neeStatus?.enabled}
                            > 
                                {t('Cambiar')}
                            </ButtonGhost>
                        </Link>
                    </Tooltip>
                </Section>
                <hr className="separator-xxs"/>
                <Section>
                    <TextLabel label={t('Nombre sentido')} value={nickname}/>
                    <Link to={linkNickname}>
                        <ButtonGhost
                            className='m-top sm-no-m-top full-width sm-no-full-width'>{t('Cambiar')}</ButtonGhost>
                    </Link>
                </Section>
            </Card>
        </div>
    )
}
